import getAgentKbRef from './getAgentKbRef';
import getAgentKbArtefactsRef from './getAgentKbArtefactsRef';
import getAgentKbRevisionsRef from './getAgentKbRevisionsRef';
import getAgentKbVersionsRef from './getAgentKbVersionsRef';
import getAgentKbPinsRef from './getAgentKbPinsRef';

const agentKb = {
  getAgentKbRef,
  getAgentKbArtefactsRef,
  getAgentKbRevisionsRef,
  getAgentKbVersionsRef,
  getAgentKbPinsRef,
};

export default agentKb;
